import {avgScoresSync, reweightAllSync} from "./scoreWeights";
import {SCORES_ESTIMATE, SCORES_AVG} from "../../workers/taskNames";
import {runTask} from "../../workers/runTask";

export const reweightAll = (locationScores, weights, scorePathNames) => {
  if (window.Worker) {
    return runTask(SCORES_ESTIMATE, locationScores, weights, scorePathNames)
  } else {
    return Promise.resolve(reweightAllSync(locationScores, weights, scorePathNames))
  }
}

export const avgScores = (scores, scorePathNames) => {
  if (window.Worker) {
    return runTask(SCORES_AVG, scores, scorePathNames)
  } else {
    return Promise.resolve(avgScoresSync(scores, scorePathNames))
  }
}
